// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-0b896afe]{justify-content:flex-end;gap:10px}.header[data-v-0b896afe],.header .search_box[data-v-0b896afe]{display:flex}.header .search_box .select[data-v-0b896afe]{width:120px}.header .search_box .input[data-v-0b896afe]{width:200px}", ""]);
// Exports
module.exports = exports;
